export default "__VITE_ASSET__T3hw2vq2__"